import { useState, useEffect } from 'react';
import { offlineStorage } from '../utils/offlineStorage';
import { CheckIn } from '../types';

export const useOffline = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCheckIns, setPendingCheckIns] = useState<CheckIn[]>([]);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Try to sync pending check-ins when we come back online
      offlineStorage.syncPendingCheckIns();
    };

    const handleOffline = () => {
      setIsOnline(false);
      // Load pending check-ins when we go offline
      offlineStorage.getPendingCheckIns().then(setPendingCheckIns);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleOfflineCheckIn = async (checkIn: CheckIn) => {
    try {
      await offlineStorage.savePendingCheckIn(checkIn);
      const updatedPending = await offlineStorage.getPendingCheckIns();
      setPendingCheckIns(updatedPending);
    } catch (error) {
      console.error('Failed to save offline check-in:', error);
      throw error;
    }
  };

  return {
    isOnline,
    pendingCheckIns,
    handleOfflineCheckIn,
  };
};
